import { render, staticRenderFns } from "./RightsShopEdit.vue?vue&type=template&id=3bec287e&scoped=true"
import script from "./RightsShopEdit.vue?vue&type=script&lang=js"
export * from "./RightsShopEdit.vue?vue&type=script&lang=js"
import style0 from "./RightsShopEdit.vue?vue&type=style&index=0&id=3bec287e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec287e",
  null
  
)

export default component.exports